import type { ProtocolEdgeType } from '@ipfabric/utils';

export const isProtocolStp = (protocol?: ProtocolEdgeType | null): boolean =>
  protocol !== undefined && protocol === 'stp';
